import { Pipe, PipeTransform } from '@angular/core';
import { TechChangeAgentDashboardListDto } from 'src/app/shared/dto';

@Pipe({
  name: 'techChangeAgentLabel',
  standalone: true,
})
export class TechChangeAgentLabelPipe implements PipeTransform {
  transform(agent: TechChangeAgentDashboardListDto | null | undefined): string {
    if (!agent) {
      return 'All Agents';
    }

    return agent.name;
  }
}
